import { useField } from "formik";
import { Form } from "components/ui/BootstrapCompat";

const CustomInput = ({ label, require, ...props }: any) => {
  const [field, meta] = useField(props);
  const showError = Boolean(meta.touched && meta.error);

  return (
    <div className="form-group">
      <label htmlFor={props.id || props.name}>
        {label} {!!require && <a style={{ color: "#F91B1B" }}>*</a>}
      </label>
      <Form.Control {...props} {...field} isInvalid={showError} />
      {showError ? (
        <div style={{ color: "red", marginLeft: 5, fontSize: 12 }}>
          {meta.error}
        </div>
      ) : null}
    </div>
  );
};

export default CustomInput;
